import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, MailIcon, ZapIcon } from 'lucide-react';
export function FinalCTASection() {
  const {
    minutes,
    seconds,
    isUrgent
  } = useCountdown(15);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  const checkoutUrl = 'https://checkout.guiadigital360.online/cart/44005388255301:1';
  return <section className="py-12 md:py-24 px-4 bg-brand-dark text-white text-center" data-id="element-85">
      <div className="max-w-4xl mx-auto" data-id="element-86">
        <div className="inline-block bg-white/10 text-white font-bold px-6 py-2 rounded-full mb-6 md:mb-8 border border-white/20" data-id="element-87">
          🧩 DESARROLLO INFANTIL 360
        </div>

        <h2 className="text-3xl md:text-5xl font-black mb-6 leading-tight" data-id="element-88">
          Estás a un paso de tener todo listo
        </h2>

        <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto mb-10" data-id="element-89">
          Podés seguir buscando, descargando cosas sueltas y armando material a
          las apuradas. O podés tener{' '}
          <span className="font-bold text-white" data-id="element-90">
            +1000 actividades organizadas, listas para imprimir y aplicar desde
            hoy.
          </span>
        </p>

        <div className="bg-[#252542] p-6 md:p-10 rounded-3xl border-2 border-brand-orange mb-8 max-w-2xl mx-auto" data-id="element-91">
          <div className="text-gray-400 text-xl line-through font-bold mb-2" data-id="element-92">
            Antes: $49.900 ARS
          </div>
          <div className="text-4xl md:text-6xl font-black text-white mb-6" data-id="element-93">
            HOY: <span className="text-brand-orange" data-id="element-94">$19.990</span> ARS
          </div>

          <div className="bg-brand-dark/50 p-4 rounded-xl mb-8 inline-block" data-id="element-95">
            <p className="text-sm text-gray-300 mb-2 font-bold uppercase tracking-wider" data-id="element-96">
              Precio de relanzamiento termina en:
            </p>
            <div className={`flex justify-center gap-2 text-2xl font-black ${isUrgent ? 'text-red-500 animate-pulse' : 'text-brand-orange'}`} data-id="element-97">
              <span data-id="element-98">{formatTime(minutes)}</span>
              <span data-id="element-99">:</span>
              <span data-id="element-100">{formatTime(seconds)}</span>
            </div>
          </div>

          <CTAButton text="SÍ, QUIERO EL PACK AHORA →" href={checkoutUrl} isLink={true} className="py-5" data-id="element-101" />
        </div>

        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 text-sm text-gray-400 font-medium mb-8" data-id="element-102">
          <span className="flex items-center gap-1" data-id="element-103">
            <ZapIcon className="w-4 h-4 text-yellow-500" data-id="element-104" /> Acceso inmediato
          </span>
          <span className="flex items-center gap-1" data-id="element-105">
            <LockIcon className="w-4 h-4" data-id="element-106" /> Mercado Pago
          </span>
          <span className="flex items-center gap-1" data-id="element-107">
            <ShieldCheckIcon className="w-4 h-4 text-brand-green" data-id="element-108" /> Garantía 7
            días
          </span>
          <span className="flex items-center gap-1" data-id="element-109">
            <MailIcon className="w-4 h-4" data-id="element-110" /> Llegá en minutos
          </span>
        </div>

        <p className="text-sm text-gray-500 bg-white/5 inline-block px-4 py-2 rounded-lg" data-id="element-111">
          <span className="font-bold text-gray-300" data-id="element-112">🔎 Tip:</span> Si no ves el
          email en unos minutos, revisá la carpeta de Spam o Promociones.
        </p>
      </div>
    </section>;
}